
import DashboardReport from "components/DashboardReport";
import Dashboard from "components/Dashboard";
import Main from "layouts/Main";
import { useAppDispatch } from "store";
import { setFooterShow } from 'store/slices/layoutSlice';




function Dashboaerd() {

  const dispatch = useAppDispatch();

  //show footer
  dispatch(setFooterShow(true));

  return (
    <>
    <Main namePage="แดชบอร์ด" subNamePage="แดสบอร์ด" >
      <div className="layout-content">
          <DashboardReport />
      </div>
      </Main>
    </>
  );
}

export default Dashboaerd;